import { z } from 'zod/v4';
import { VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '../vouchers/index.js';
import { VoucherTypeMatcherSchema } from '../vouchers/matcher.js';
// A grouped row sums the vouchers the matcher selects
export const GroupBySchema = VoucherTypeMatcherSchema.extend({
    label: z.string(),
});
export var CaseVoucherTableType;
(function (CaseVoucherTableType) {
    // One row per case voucher, optionally grouped/filtered
    CaseVoucherTableType["Standard"] = "STANDARD";
    // Chronological statement with interest accrual rows and running balances
    CaseVoucherTableType["Ledger"] = "LEDGER";
})(CaseVoucherTableType || (CaseVoucherTableType = {}));
export const CaseVoucherTableConfigSchema = z.object({
    name: z.string(),
    description: z.string(),
    handle: z.string(),
    // Missing on configs saved before the ledger type existed, meaning Standard
    type: z.enum(CaseVoucherTableType).optional(),
    groupBy: z.array(GroupBySchema).optional(),
    includeDeleted: z.boolean().optional(),
    excludeDate: z.boolean().optional(),
    includeDueDate: z.boolean().optional(),
    includeFIKPaymentDetails: z.boolean().optional(),
    excludeNotDueCaseVouchers: z.boolean().optional(),
    excludeHeader: z.boolean().optional(),
    excludeSumRow: z.boolean().optional(),
    showDepositDistribution: z.boolean().optional(),
    showInterestCalculationDetails: z.boolean().optional(),
    excludeFromSubtotal: VoucherTypeMatcherSchema.optional(),
    showSubTotalPerCaseVoucher: z.boolean().optional(),
    include: z
        .array(z.object({
        categories: z.array(z.enum(VoucherCategory)),
        includeReferenceCaseVouchers: z.boolean(),
    }))
        .optional(),
    filterByProperties: z
        .array(z.object({
        match: z.boolean(),
        propertyTypeId: z.string(),
        value: z.union([z.string(), z.number(), z.boolean()]),
    }))
        .optional(),
});
export const getCaseVoucherTables = (customTables, lang) => {
    let tables = DefaultCaseVoucherTables(lang);
    // Custom tables are added after default so they can override the default ones
    tables = tables.concat(customTables);
    return tables;
};
export const DKDebtTable = (lang) => ({
    name: lang.caseVoucherTableLabels.overview,
    description: lang.caseVoucherTableLabels.overview,
    handle: 'DKoverview',
    groupBy: [
        {
            label: lang.mentionContent.reminderFeeRow,
            voucherTypeIds: [VoucherTypeIds.REMINDERFEE],
        },
        {
            label: lang.mentionContent.debtCollectionFeeRow,
            voucherTypeIds: [VoucherTypeIds.COLLECTIONFEE],
        },
        {
            label: lang.mentionContent.debtCollectionCostRow,
            voucherTypeIds: [VoucherTypeIds.COLLECTIONCOST],
        },
        {
            label: lang.mentionContent.compensationFeeRow,
            voucherTypeIds: [VoucherTypeIds.COMPENSATIONCOST],
        },
        {
            label: lang.mentionContent.processInterestRow,
            voucherTypeIds: [VoucherTypeIds.PROCESSINTEREST],
        },
        {
            label: lang.mentionContent.fixedInterestRow,
            voucherTypeIds: [VoucherTypeIds.FIXEDINTEREST],
        },
        {
            label: lang.mentionContent.yearlyInterestRow,
            voucherTypeIds: [VoucherTypeIds.YEARLYINTEREST],
        },
        {
            label: lang.mentionContent.paid,
            settings: [VoucherTypeSetting.Payment],
        },
    ],
    includeDeleted: false,
    excludeHeader: true,
});
const DefaultCaseVoucherTables = (lang) => [
    DKDebtTable(lang),
    {
        name: lang.caseVoucherTableLabels.detailed,
        description: lang.caseVoucherTableLabels.detailed,
        handle: 'detailed',
        groupBy: [],
        includeDeleted: false,
        excludeHeader: true,
    },
    {
        name: lang.caseVoucherTableLabels.principalWithReferenceCaseVouchers,
        description: lang.caseVoucherTableLabels.principalWithReferenceCaseVouchers,
        handle: 'principalWithReferenceCaseVouchers',
        groupBy: [],
        includeDeleted: false,
        include: [
            {
                categories: [VoucherCategory.PRINCIPAL],
                includeReferenceCaseVouchers: true,
            },
        ],
        excludeSumRow: true,
        excludeHeader: false,
        includeDueDate: true,
    },
];
//# sourceMappingURL=tables.js.map